import script from "./TradeOrderDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./TradeOrderDashboard.vue?vue&type=script&setup=true&lang=js"

import "./TradeOrderDashboard.vue?vue&type=style&index=0&id=1615ba8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1615ba8a"]])

export default __exports__